import { Flex, Form } from "antd";

import { getRepeatText } from "@/utils/repeatText";

const ResultInfo = ({ form }) => {
  const end_date = Form.useWatch("end_date", form); // Дата окончания
  const repeat_count = Form.useWatch("repeat_count", form); // Кол-во повторений
  const n_count = Form.useWatch("n_count", form); // По дням
  const m_count = Form.useWatch("m_count", form); // По неделям
  const only_workdays = Form.useWatch("only_workdays", form); // По будням

  const weeks_days = Form.useWatch("weeks_days", form); // Дни недели для повторения
  const monthly_frequency_option = Form.useWatch(
    "monthly_frequency_option",
    form
  ); // По месяцам
  const monthly_frequency_val_1 = Form.useWatch(
    "monthly_frequency_val_1",
    form
  ); // По месяцам
  const monthly_frequency_val_2 = Form.useWatch(
    "monthly_frequency_val_2",
    form
  ); // По месяцам
  const monthly_frequency_val_3 = Form.useWatch(
    "monthly_frequency_val_3",
    form
  ); // По месяцам
  const monthly_frequency_val_4 = Form.useWatch(
    "monthly_frequency_val_4",
    form
  ); // По месяцам
  const monthly_frequency_val_5 = Form.useWatch(
    "monthly_frequency_val_5",
    form
  ); // По месяцам
  const frequency_by_year_val_1 = Form.useWatch(
    "frequency_by_year_val_1",
    form
  ); // По годам
  const frequency_by_year_val_2 = Form.useWatch(
    "frequency_by_year_val_2",
    form
  ); // По годам
  const frequency_by_year_val_3 = Form.useWatch(
    "frequency_by_year_val_3",
    form
  ); // По годам

  return (
    <div
      style={{
        margin: "0 -24px",
        background: "#fff",
        padding: "16px 24px",
      }}
    >
      <Flex vertical gap={6}>
        <div style={{ color: "#777777" }}>Результат</div>
        <div>
          {getRepeatText({
            end_date,
            repeat_count,
            n_count,
            m_count,
            only_workdays,
            weeks_days,
            monthly_frequency_option,
            monthly_frequency_val_1,
            monthly_frequency_val_2,
            monthly_frequency_val_3,
            monthly_frequency_val_4,
            monthly_frequency_val_5,
            frequency_by_year_val_1,
            frequency_by_year_val_2,
            frequency_by_year_val_3,
          })}
        </div>
      </Flex>
    </div>
  );
};

export default ResultInfo;
